export default {
  WIN_HOME: 0,
  WIN_AWAY: 1,
  DRAW: 2,
  0: 'w1',
  1: 'w2',
  2: 'x',
};
